export default {
	default: "admin",

	routes: {
		admin: {
			routes: [
                {
                    icon: "mdi-accounts",
                    title: "לקוחות",
                    to: "clients-view",
                },
                {
                    icon: "mdi-tags",
                    title: "כרטיסים",
                    to: "cards-view",
                },
                // {
                //     icon: "mdi-accounts",
                //     title: "משתמשים",
                //     to: "users-view",
                // },
                {
                    icon: "mdi-accounts",
                    title: "הגרלות",
                    to: "lottery-view",
                },
                {
                    icon: "mdi-accounts",
                    title: "הגרלה",
                    to: "lottery-iframe",
                },

			],
		},
        manager: {
            routes: [
                {
                    icon: "mdi-accounts",
                    title: "לקוחות",
                    to: "clients-view",
                },{
                    icon: "mdi-tags",
                    title: "כרטיסים",
                    to: "cards-view",
                },
                {
                    icon: "mdi-accounts",
                    title: "הגרלות",
                    to: "lottery-view",
                },
                {
                    icon: "mdi-accounts",
                    title: "הגרלה",
                    to: "lottery-iframe",
                },

            ],
		}
	},
};
